import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7c00290a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7c00290a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c00290a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c00290a')) {
      api.createRecord('7c00290a', component.options)
    } else {
      api.reload('7c00290a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7c00290a&scoped=true&", function () {
      api.rerender('7c00290a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform-items/modals/ItemSidesheet/index.vue"
export default component.exports